<template>
  <div class="p-10">
    <div class="card pb-0 px-5 mb-5 pt-4">
      <div class="d-flex flex-column flex-md-row justify-content-between">
        <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-3 mb-md-0">
          <li class="nav-item" @click="clickOnTab('kt_reports',)">
            <a class="nav-link text-active-primary pb-4" :class="{ 'active' : route.query.tab === 'kt_reports' || !route.query.tab }"  data-bs-toggle="tab" href="#kt_reports">Rapports des dossiers</a>
          </li>

          <li class="nav-item" @click="clickOnTab('kt_formalities',)">
            <a class="nav-link text-active-primary pb-4" :class="{ 'active' : route.query.tab === 'kt_formalities' }"  data-bs-toggle="tab" href="#kt_formalities">{{ $t('projects.formalities') }}</a>
          </li>
        </ul>
        <div class="d-flex justify-content-end mb-5">

        </div>
      </div>
    </div>
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show" :class="{ 'active': isActive('kt_reports') }"  id="kt_overview" role="tabpanel">
        <ProjectReports v-if="isActive('kt_reports')" />
      </div>

      <div class="tab-pane fade show" :class="{ 'active': isActive('kt_formalities') }"  id="kt_formalities" role="tabpanel">
        <ProjectFormalities v-if="isActive('kt_formalities')" />
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import {useRouter, useRoute} from "vue-router";
import ProjectReports from "@/Modules/Projects/views/Reports/components/ProjectReports.vue";
import ProjectFormalities from "@/Modules/Projects/views/Reports/components/ProjectFormalities.vue";

const store = useStore()
const router = useRouter()
const route = useRoute()

const activeTab = computed(() => route.query.tab || 'kt_reports');
const isActive = (tabId) => activeTab.value === tabId;
function clickOnTab(tabId){
  router.replace({ query: { ...route.query, tab: tabId } }); 
}

</script>